'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'calculator-simple';
var width = 512;
var height = 512;
var aliases = ["calculator-alt"];
var unicode = 'f64c';
var svgPathData = 'M168.1 343c-9.375-9.375-24.56-9.375-33.94 0L112 366.1l-23.03-23.03c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L78.06 400l-23.03 23.03c-9.375 9.375-9.375 24.56 0 33.94C59.72 461.7 65.84 464 72 464s12.28-2.344 16.97-7.031L112 433.9l23.03 23.03C139.7 461.7 145.8 464 152 464s12.28-2.344 16.97-7.031c9.375-9.375 9.375-24.56 0-33.94L145.9 400l23.03-23.03C178.3 367.6 178.3 352.4 168.1 343zM64 134.9h96c13.25 0 24-10.75 24-24s-10.75-24-24-24H64c-13.25 0-24 10.75-24 24S50.75 134.9 64 134.9zM344 136.1h32v32c0 13.25 10.75 23.92 24 23.92s24-10.67 24-23.92v-32h32c13.25 0 24-10.83 24-24.08s-10.75-23.92-24-23.92h-32v-32c0-13.25-10.75-24.08-24-24.08s-24 10.83-24 24.08v32h-32c-13.25 0-24 10.67-24 23.92S330.8 136.1 344 136.1zM488 232h-208v-208C280 10.75 269.3 0 256 0S232 10.75 232 24v208h-208C10.75 232 0 242.8 0 256s10.75 24 24 24h208v208C232 501.3 242.8 512 256 512s24-10.75 24-24v-208h208C501.3 280 512 269.3 512 256S501.3 232 488 232zM448 416h-96.06C338.7 416 328 426.8 328 440S338.8 464 352 464h96c13.25 0 24-10.75 24-24S461.3 416 448 416zM448 336h-96c-13.25 0-24 10.75-24 24S338.7 384 351.1 384h96.06C461.3 384 472 373.3 472 360S461.3 336 448 336z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalculatorSimple = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;